import { Swiper } from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export default function initCarouselHero() {
  const container = document.querySelector(".swiper-hero");
  if (!container) return;

  const slides = container.querySelectorAll(".swiper-slide");
  const showNav = slides.length > 1;

  new Swiper(container, {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    allowTouchMove: true,
    navigation: showNav
      ? {
          nextEl: ".swiper-hero-next",
          prevEl: ".swiper-hero-prev",
        }
      : false,
    pagination: showNav
      ? {
          el: ".swiper-hero-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            return (
              '<span class="' + className + ' swiper-pagination-bullet-custom"></span>'
            );
          },
        }
      : false,
  });
}
